import styled from 'styled-components';

export const StyledFourthStep = styled.div`
  .fs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .terms {
      display: flex;
      gap: 8px;

      > .MuiCheckbox-root {
        padding: 0;
        margin-top: -14px;
      }

      > p {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0%;

        > span {
          color: var(--color-primary-blue);
          cursor: pointer;
        }
      }
    }
  }
`;

export const StyledFourthStepBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  > div {
    width: 342px;
    height: 65px;
    margin-bottom: 0;

    > .datePickerWrapper {
      overflow: hidden;
    }

    &.no-label {
      > span {
        color: transparent;
        user-select: none;

        > span {
          color: transparent;
          user-select: none;
        }
      }
    }
  }
`;
